/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNav_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly profile: {
        readonly firstName: string | null;
    } | null;
    readonly conversationSummary: {
        readonly unread: number | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_user" | "TradeAccountNavContent_user">;
    readonly " $refType": "AccountNav_user";
};
export type AccountNav_user$data = AccountNav_user;
export type AccountNav_user$key = {
    readonly " $data"?: AccountNav_user$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNav_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "firstName",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "conversationSummary",
      "storageKey": null,
      "args": null,
      "concreteType": "Summary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "unread",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "AccountNavContent_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeAccountNavContent_user",
      "args": null
    }
  ]
};
(node as any).hash = '633a61818e0cd93a621eda8863b5166b';
export default node;
